import React, { useRef, useState, useEffect } from "react";
import { Galleria } from "primereact/galleria";
import Utils, { ATTACHMENT_TYPES } from "utils";
import snapPreview from "assets/img/snap-preview.svg";
import { TaskService } from 'services/http';
import utils from 'utils';

export const Attachment = (props) => {

    const displayerRef = useRef();
    const [loadingAttachment, setLoadingAttachment] = useState();
    const [attachments, setAttachments] = useState(props.attachments);
    const [attachmentError, setAttachmentError] = useState();

    const ElementContainer = (props) => {
        return (
            <div className="col" style={{ padding: "3px" }}>
                {props.children}
            </div>
        );
    }

    useEffect(() => {
        if (attachments.length > 0 && !attachments.find(attachment => attachment.attachmentType === "fallback")) {
            syncronizeAttachments();
        }
    }, []);

    const syncronizeAttachments = () => {
        setLoadingAttachment(true);
        TaskService.syncronizeAttachment(props.msgId).then(res => {
            setAttachments(res.result)
        }).catch(err => {
            setAttachmentError(err);
        }).finally(() => {
            setLoadingAttachment(false)
        });
    }

    return (
        <div className="row" style={{ padding: "0 10px" }}>
            {
                props.attachments.map((attachment) => {
                    switch (attachment.attachmentType) {
                        case (ATTACHMENT_TYPES.IMAGE): {
                            return (
                                <ElementContainer>
                                    <AttachmentTemplate
                                        loading={loadingAttachment}
                                        error={attachmentError}>
                                        <img src={attachment.payloadUrl} loading="lazy" alt="img" className="img-fluid" width="150px" style={{ cursor: "pointer" }} onClick={() => { displayerRef.current.show(); }} />
                                        <Galleria
                                            ref={displayerRef}
                                            fullScreen
                                            circular
                                            showItemNavigators={attachments.length > 1}
                                            showIndicators
                                            value={attachments}
                                            item={(item) => { return <img src={item.payloadUrl} className="rounded mx-aut" height={`500px`} alt="img" /> }} />
                                    </AttachmentTemplate>
                                </ElementContainer>
                            );
                        }
                        case (ATTACHMENT_TYPES.FILE): {
                            return (
                                <ElementContainer>
                                    <AttachmentTemplate
                                        loading={loadingAttachment}
                                        error={attachmentError}>
                                        <a href={attachment.payloadUrl} title="download" target="_blank" rel="noreferrer">
                                            <i className="pi pi-paperclip" />&nbsp;{utils.retrieveFileNameFromURL(attachment.payloadUrl)}
                                        </a>
                                    </AttachmentTemplate>
                                </ElementContainer>
                            );
                        }
                        case (ATTACHMENT_TYPES.VIDEO): {
                            return (
                                <ElementContainer>
                                    <AttachmentTemplate
                                        loading={loadingAttachment}
                                        error={attachmentError}>
                                        <video
                                            allowFullScreen height={attachment.height ? attachment.height * 0.5 : '200'}
                                            width={attachment.width ? attachment.width * 0.5 : '300'}
                                            title="video" controls>
                                            <source src={attachment.payloadUrl} type="video/mp4" />
                                            Sorry, your browser doesn't support embedded videos.
                                        </video>
                                    </AttachmentTemplate>
                                </ElementContainer>
                            );
                        }
                        case (ATTACHMENT_TYPES.AUDIO): {
                            return (
                                <ElementContainer>
                                    <AttachmentTemplate
                                        loading={loadingAttachment}
                                        error={attachmentError}>
                                        <audio controls autoplay style={{ outline: 0 }}>
                                            <source src={attachment.payloadUrl} />
                                            Your browser does not support the audio element.
                                        </audio>
                                    </AttachmentTemplate>
                                </ElementContainer>
                            );
                        }
                        case (ATTACHMENT_TYPES.FALLBACK): {
                            let fallbackURL = attachment.payloadUrl ? attachment.payloadUrl : props.content;
                            return (
                                <ElementContainer>
                                    <a href={fallbackURL} title="visit" target="_blank" rel="noreferrer">
                                        <div className="d-flex justify-content-between">
                                            <i className="fab fa-facebook-square mr-2" style={{ fontSize: "40px" }} />
                                            <div>
                                                <div className="font-weight-bold text-dark" ><strong>Fallback Link</strong></div>
                                                <span>{Utils.shorthandString(fallbackURL, 40)}</span>
                                            </div>
                                        </div>
                                    </a>
                                </ElementContainer>
                            );
                        }
                        case (ATTACHMENT_TYPES.LOCATION): {
                            let locationURL = attachment.payloadUrl ? attachment.payloadUrl : props.content;
                            return (
                                <ElementContainer>
                                    <a href={locationURL} title="visit" target="_blank" rel="noreferrer">
                                        <div className="d-flex justify-content-between">
                                            <i className="fab fa-facebook-square mr-2" style={{ fontSize: "40px" }} />
                                            <div>
                                                <div className="font-weight-bold text-dark" ><strong> <i className="bi bi-map-fill" /> Location Link</strong></div>
                                                <span>{Utils.shorthandString(locationURL, 40)}</span>
                                            </div>
                                        </div>
                                    </a>
                                </ElementContainer>
                            );
                        }
                        default: {
                            return <a href={attachment.payloadUrl} className="px-2"> {Utils.shorthandString(attachment.payloadUrl, 45) || 'Forwaded Link'}</a>
                        }
                    }
                })
            }
        </div >
    );
}


export const AttachmentTemplate = (props) => {

    const { loading, error } = props;

    return (<>
        {
            loading ?
                <div style={{ width: "150px", marginTop: "-25px" }}>
                    <SVGLoader label="Loading..." />
                </div>
                : error ?
                    <div style={{ width: "150px" }}>
                        <img src={snapPreview} className="img-fluid" alt="img" />
                        <br />
                        <small className="text-danger">{error}</small>
                    </div> : props.children
        }
    </>)
}


export let SVGLoader = (props) => {
    const { label } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" style={{ margin: "auto", display: "block" }} width="120px" height="120px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" r="16" stroke-width="3" stroke="#4dadd9" stroke-dasharray="25.132741228718345 25.132741228718345" fill="none" stroke-linecap="round">
                <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
            </circle>
            <circle cx="50" cy="50" r="11" stroke-width="3" stroke="#60c1e6" stroke-dasharray="17.27875959474386 17.27875959474386" stroke-dashoffset="17.27875959474386" fill="none" stroke-linecap="round">
                <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
            </circle>
            <g>
                <rect x="0" y="0" ></rect>
                <text x="30" y="85" font-family="Verdana" font-size="10" >{label}</text>
            </g>
        </svg>
    )
}